// extracted by mini-css-extract-plugin
export var caseList = "detail-module--caseList--cVzUE";
export var summary = "detail-module--summary--5svou";
export var title = "detail-module--title--KknWx";